export default "__VITE_ASSET__Cjtx1hhW__"